import { api } from "@/integrations/clients/carAuction/carAuctionClient";

export type NativeAppConfig = {
  minAppVersion: string;
  latestAppVersion: string;
  forceUpdate: boolean;
  androidStoreUrl: string;
  iosStoreUrl: string;
};

export async function fetchNativeAppConfig(): Promise<NativeAppConfig> {
  const response = await api.get<{ success: boolean; data: NativeAppConfig }>(
    "/app/native-config",
  );
  if (!response.success || !response.data) {
    throw new Error("Failed to load app config");
  }
  return response.data;
}
